module.exports = __webpack_public_path__ + "img/kissing_heart.926a53fc.png";